<template>
    <nav v-if="pagination.total > 15">
    <!-- <nav> -->
        <span class="pt-20 pull-left">Showing {{ pagination.from }} to {{ pagination.to }} of {{ pagination.total }} entries</span>
        <ul class="pagination pt-10 pull-right">
            <li v-if="pagination.current_page > 1">
                <a href="javascript:void(0)" aria-label="First" @click.prevent="changePage(1)">
                    <span aria-hidden="true"><i class="fa fa-angle-double-left position-left"></i> First</span>
                </a>
                <a href="javascript:void(0)" aria-label="Previous" @click.prevent="changePage(pagination.current_page - 1)">
                    <span aria-hidden="true"><i class="icon-arrow-left22"></i> Previous</span>
                </a>
            </li>
            <li v-for="page in pagesNumber" :class="{'active': page == pagination.current_page}">
                <a href="javascript:void(0)" @click.prevent="changePage(page)">{{ page }}</a>
            </li>
            <li v-if="pagination.current_page < pagination.last_page">
                <a href="javascript:void(0)" aria-label="Next" @click.prevent="changePage(pagination.current_page + 1)">
                    <span aria-hidden="true">Next <i class="icon-arrow-right22"></i></span>
                </a>
                <a href="javascript:void(0)" aria-label="Last" @click.prevent="changePage(pagination.last_page)">
                    <span aria-hidden="true">Last<i class="fa fa-angle-double-right position-right"></i></span>
                </a>
            </li>
        </ul>
    </nav>
</template>

<script>
export default {
    name: 'Pagination',
    props: {
        pagination: {
            type: Object,
            required: true
        },
        offset: {
            type: Number,
            default: 4
        }
    },
    computed: {
        pagesNumber: function () {
            if (!this.pagination.to) {
                return [];
            }
            var from = this.pagination.current_page - this.offset;
            if (from < 1) {
                from = 1;
            }
            var to = from + (this.offset * 2);
            if (to >= this.pagination.last_page) {
                to = this.pagination.last_page;
            }
            var pagesArray = [];
            for (from = 1; from <= to; from++) {
                pagesArray.push(from);
            }
            return pagesArray;
        }
    },
    methods : {
        changePage: function (page) {
            this.pagination.current_page = page;
        }
    }
}
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/admin/master/Pagination.vue